import cn from "classnames";
import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./AcquisitionsCard.module.scss";

const renderValueByKey = (value: any, key: string) => {
  switch (key) {
    case "quantity":
      return convertValueToLocale(value, null, "€", null);
    case "percentage":
      return convertValueToLocale(value, 2, "%");
    default:
      return value;
  }
};

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const value =
        cellType !== "boolean" ? item[key] || "" : item[key] || false;

      const investObject = item?.investObject;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography
            className={cn(styles.text, {
              [styles.sumText]: investObject === "Summe",
            })}
            variant="numbers"
          >
            {renderValueByKey(value, key)}
          </Typography>
        </div>
      );
    }
  }
};

const AcquisitionsCard = ({ items, columns }: any) => {
  return (
    <DetailedTable
      title="Erwerbsnebenkosten"
      data={items}
      columns={columns}
      cellRenderer={(props) => _cellRenderer(props)}
    />
  );
};

export default AcquisitionsCard;
